<template>
  <div id="device-bg-main">
    <home-page />
  </div>
</template>

  <script>
  import HomePage from '../components/SelectUserPage.vue';
    export default {
      name: 'Home',
      components: {
        HomePage,
      },
    };
  </script>
